import { createStyles, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

const styles = createStyles(theme => ({
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  decoratedLink: {
    color: theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightBold,
    transition: theme.transitions.create(
      'color',
      { duration: theme.transitions.duration.shortest },
    ),
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

const CommonLink = React.forwardRef((props, ref) => {
  const { classes, className, style, decorate = true, to, children } = props;
  
  if (!to) {
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    );
  }
  
  const parsedClassName = classNames(
    classes.link,
    decorate && classes.decoratedLink,
    className,
  );
  const probablePath = to && (typeof to === 'string' ? to : to.pathname);
  const isLocal = probablePath && probablePath.startsWith('/');
  
  if (isLocal) {
    return (
      <Link
        ref={ref}
        style={style}
        className={parsedClassName}
        to={to}
      >
        {children}
      </Link>
    );
  }
  
  const path = typeof to === 'string' ? to : `${to.pathname}${to.search}${to.hash}`;
  return (
    <a
      ref={ref}
      style={style}
      className={parsedClassName}
      href={path}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
});

export default withStyles(styles, { name: 'CommonLink' })(CommonLink);
